<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" fullscreen transition="dialog-bottom-transition" :overlay="false">
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon @click.native="closeDialog" dark>
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title v-if="job !== null" v-html="this.job.vehicle !== undefined ? 'Vehicle: ' + this.job.vehicle : 'Vehicle: ' + this.job.reg"></v-toolbar-title>
          <v-spacer></v-spacer>
          <v-tooltip v-if="role !== 'Supplier'" bottom>
            <template v-slot:activator="{ on }">
              <v-btn @click="approveJob" icon v-on="on" v-if="jobState === 2 || jobState === 1"><v-icon>done</v-icon></v-btn>
            </template>
            <span>The Gary Day Button</span>
          </v-tooltip>
          <v-tooltip v-if="role !== 'Supplier'" bottom>
            <template v-slot:activator="{ on }">
              <v-btn @click="flagJobIssue" icon v-on="on" v-if="jobState > 1"><v-icon>warning</v-icon></v-btn>
            </template>
            <span>Flag Issue With Job</span>
          </v-tooltip>
          <v-btn v-if="role !== 'Supplier'" @click="fixBrokenImage" icon><v-icon>mdi-image-broken-variant</v-icon></v-btn>
          <v-btn @click="print" icon><v-icon>print</v-icon></v-btn>
          <v-btn @click="show" icon><v-icon>view_carousel</v-icon></v-btn>
        </v-toolbar>
        <div v-if="fetchingJob" class="text-xs-center">
            <v-progress-circular
              class="mt-5"
              :size="70"
              :width="7"
              color="primary"
              indeterminate
            ></v-progress-circular>
        </div>
        <div class="blue lighten-5 px-5" v-if="attachedDocs">
          <h5>Job Attachments</h5>
          <v-list-tile v-for="doc in attachedDocs" :key="doc.name">
            <v-list-tile-avatar><v-icon>mdi-file-document-outline</v-icon></v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title>
                <a :href="doc.downloadUrl" target="_BLANK">{{doc.name}}</a>
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </div>
        <v-layout v-if="job !== null" row wrap>
          <v-flex lg12 v-if="job.startTime">
            <strong><v-icon>mdi-flag</v-icon> Start Time:</strong> {{job.startTime|formatDate}}
            <strong><v-icon>mdi-flag-checkered</v-icon> End Time:</strong> {{job.endTime|formatDate}}
            <strong><v-icon>mdi-clock</v-icon> Total:</strong> {{(job.endTime - job.startTime)|milisecondToMinutes }}
            <h4 v-if="job.notes">General Job Notes</h4>
            <p>{{job.notes}}</p>
          </v-flex>
          <v-flex lg6>
            <v-expansion-panel dark v-for="(temp, index) in job.template" v-bind:key="index">
              <v-expansion-panel-content>
                <div slot="header"><strong>{{ temp.name }}</strong></div>
                <v-card v-for="(item, ni) in temp.items" v-bind:key="ni">
                  <v-list>
                    <v-list-tile :class="item.image.length > 0 || item.note.length > 0 ? 'green--text' : 'grey--text'" @click="loadImage(item, index, ni)">
                      <v-list-tile-content>
                        <v-list-tile-title>{{ item.text }}</v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>
                  </v-list>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-flex>
          <v-flex lg6 text-xs-center>
            <p v-if="currentNote !== ''">{{currentNote}}</p>
            <img v-if="currentImage !== ''" :src="currentImage" style="width: 60%;">
          </v-flex>
        </v-layout>
        <div v-viewer="{title:(image) => `${image.alt}`}" class="images clearfix" hidden>
          <template v-for="image in images">
            <img :src="image.image" width="100" class="image ma-2" :key="image.image" :alt="image.title">
          </template>
        </div>
      </v-card>
      <v-dialog v-model="testingDialog" fullscreen>
        <v-card>
          <v-toolbar dark color="primary">
            <v-btn icon dark @click="testingDialog = false">
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>Testing</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn dark flat @click="testingDialog = false">Close</v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <testing :UID="testsUID" :activeTestUID="activeTest"/>
        </v-card>
      </v-dialog>
    </v-dialog>
  </v-layout>
</template>

<script>
import { fireStore, storage } from '../firebase'
import moment from 'moment'
export default {
  props: ['JobID', 'visible'],
  data () {
    return {
      job: null,
      jobState: 2,
      currentNote: '',
      currentImage: '',
      currentImageName: null,
      selectedItem: null,
      selectedTemplate: null,
      fetchingJob: false,
      attachedDocs: [],
      testingDialog: false,
      activeTest: null,
      testsUID: null
    }
  },
  filters: {
    formatDate (val) {
      return moment(val, 'x').format('DD/MM/YYYY HH:mm')
    },
    milisecondToMinutes (val) {
      return Math.round(val / 60000) + ' Minutes'
    }
  },
  computed: {
    role () {
      return this.$store.getters.userData.Role
    },
    dialog () {
      return this.visible
    },
    images () {
      let images = []
      if (this.job !== null) {
        if (this.job.template !== undefined) {
          this.job.template.forEach(template => {
            if (template.items) {
              template.items.forEach(item => {
                if (item.image !== '') {
                  if (item.note) {
                    images.push({image: item.image, title: item.title + '\r' + item.note})
                  } else {
                    images.push({image: item.image, title: item.title})
                  }
                }
              })
            }
          })
        }
      }
      return images
    }
  },
  watch: {
    visible: function (val) {
      if (val) {
        this.getJob(this.JobID)
        this.getJobState(this.JobID)
      }
    }
  },
  methods: {
    approveJob () {
      this.$emit('approveJob', this.JobID)
      this.closeDialog()
    },
    flagJobIssue () {
      this.$emit('issueJob', this.JobID)
      this.closeDialog()
    },
    getJob (val) {
      this.job = null
      this.fetchingJob = true
      if (val !== '') {
        fireStore.collection('Jobs').doc(this.JobID).collection('CompletedJobs')
        .get()
        .then(snap => {
          snap.forEach(doc => {
            this.job = doc.data()
          })
          this.fetchingJob = false
        })
      }
    },
    getJobState (val) {
      this.jobState = 2
      if (val !== '') {
        fireStore.collection('Jobs').doc(this.JobID)
        .get()
        .then(doc => {
          this.attachedDocs = doc.data().completedDocs
          this.jobState = doc.data().Status
        })
      }
    },
    closeDialog () {
      this.currentNote = ''
      this.currentImage = ''
      this.$emit('update:visible', false)
    },
    show () {
      document.querySelector('.image').click()
    },
    loadImage (item, templateIndex, key) {
      console.log(item)
      this.selectedTemplate = templateIndex
      this.selectedItem = key
      this.currentImage = ''
      this.currentNote = ''
      this.activeTest = null
      this.testsUID = null
      if (item.image !== '') {
        this.currentImage = item.image
        this.currentImageName = item.imageName
        this.currentNote = item.note
      } else if (item.note !== '' && !item.test) {
        this.currentImageName = null
        this.currentNote = item.note
      } else if (item.test) {
        if (item.note == -1) {
          this.currentImageName = null
          this.currentNote = 'Test was attempted but not successfully completed'
        } else {
          let testDetails = item.note.split('/tests/')
          this.activeTest = testDetails[1]
          this.testsUID = testDetails[0]
          this.testingDialog = true
        }
      }
    },
    print () {
      var mywindow = window.open('', 'PRINT')

      mywindow.document.write('<html><head><title>Install Report - Job: ' + this.job.JobNo + '</title><link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/materialize/1.0.0/css/materialize.min.css"><style>@media print{#hidePrint{display:none;}}</style>')
      mywindow.document.write('</head><body>')
      mywindow.document.write('<div style="margin-top:10px;" id="hidePrint">Once all images are downloaded click print --> <button class="btn" onclick="window.print();window.close();">Print</button></div>')
      mywindow.document.write('<img style="margin:3px;" width="200" src="../static/img/Cubo-Logo.png" />')
      if (this.job.vehicle !== undefined) {
        mywindow.document.write('<h3>Vehicle: ' + this.job.vehicle + '</h3>')
      } else if (this.job.reg !== undefined) {
        mywindow.document.write('<h3>Vehicle: ' + this.job.reg + '</h3>')
      } else {
        mywindow.document.write('<h3>Job: ' + this.job.JobNo + '</h3>')
      }
      if (this.job.Date !== undefined) {
        mywindow.document.write('<h3>Date: ' + moment(this.job.Date).format('DD/MM/YYYY') + '</h3>')
      }
      for (let item in this.job.template) {
        mywindow.document.write('<h5>' + this.job.template[item].name + '</h5>')
        for (let subitem in this.job.template[item].items) {
          let subitemDetail = this.job.template[item].items[subitem]
          if (subitemDetail.image.length > 0) {
            mywindow.document.write('<img style="margin:3px;" height="300" src="' + subitemDetail.image + '" />')
          } else if (subitemDetail.note.length > 0) {
            mywindow.document.write('<div style="width:200px; display:inline-block;"><span style="margin:3px;">' + subitemDetail.text + ': <strong>' + subitemDetail.note + '</strong></span></div>')
          }
        }
      }

      mywindow.document.close() // necessary for IE >= 10
      mywindow.focus() // necessary for IE >= 10*/

      return true
    },
    fixBrokenImage () {
      let imgLocation = ''
      if (!this.currentImageName) {
        let img = this.currentImage.replace('https://firebasestorage.googleapis.com/v0/b/engineer-ae17e.appspot.com/o/', '')
        img = img.split('?')
        imgLocation = img[0]
      } else {
        imgLocation = this.job.JobNo + '/' + this.currentImageName
      }
      console.log(imgLocation)
      storage.ref(decodeURIComponent(imgLocation)).getDownloadURL()
      .then(downloadURL => {
        let obj = this.job.template[this.selectedTemplate]['items'][this.selectedItem]
        obj.image = downloadURL
        this.job.template[this.selectedTemplate]['items'][this.selectedItem] = Object.assign({}, this.job.template[this.selectedTemplate]['items'][this.selectedItem], obj)
        this.loadImage(obj, this.selectedTemplate, this.selectedItem)
        fireStore.collection('Jobs').doc(this.JobID).collection('CompletedJobs').get()
        .then(snap => {
          snap.forEach(doc => {
            fireStore.collection('Jobs').doc(this.JobID).collection('CompletedJobs').doc(doc.id).update(this.job)
            .then(result => {
              console.log(result)
            })
            .catch(error => {
              console.log(error)
            })
          })
        })
      })
    }
  }
}
</script>

<style>
  .viewer-container>.viewer-title{
    font-size: 1.6rem!important;
    font-family: Arial, Helvetica, sans-serif;
    overflow: visible!important;
    white-space: pre-wrap!important;
    font-style: italic;
  }
  .viewer-title::first-line{
    font-weight: bolder;
    font-style: normal;
  }
</style>



// WEBPACK FOOTER //
// CompletedJobViewComponent.vue?239067f3